<script setup lang="ts">
import { computed} from 'vue';
import AnkorstorePlusBadge from '@monolith/legacy/modules/promote-engage/subscription-program/UI/ankorstore-plus-badge.vue';
import { AkTooltipInformation, AkButton, AkParagraph } from '@ankorstore/design-system';
import { OfferProgramEligibility } from '@monolith/legacy/modules/promote-engage/services/offer';
import { useStore } from '@core/composables/use-store';
import { useI18n } from 'vue-i18n';

defineOptions({ name: 'AksPlusTooltip' });

withDefaults(
  defineProps<{
    title: string;
    tooltipPosition?: 'top' | 'right' | 'bottom' | 'left';
  }>(),
  {
    tooltipPosition: 'right',
  }
);

const { t } = useI18n();
const store = useStore();

const ankorstorePlus = computed((): OfferProgramEligibility | null => {
  return store.getters['offers/ankorstorePlus'];
});

const shouldShowTooltip = computed(() => {
  return ankorstorePlus.value && !ankorstorePlus.value.optIn;
});
</script>

<template>
  <AkTooltipInformation
    v-if="shouldShowTooltip"
    class="program_tooltip"
    :placement="tooltipPosition"
    trigger="hover"
    type="invert"
    custom-class="tooltip-aks-plus"
    data-testid="tooltipAksPlus"
  >
    <AkIcon
      symbol="info-circle"
      size="md"
      class="ds-ml-4"
    />
    <template #container>
      <AkHeading4> <AnkorstorePlusBadge class="ds-mr-2" />{{ title }} </AkHeading4>
      <AkParagraph size="sm">
        {{ t('ankorstorePlusPill.content') }}
      </AkParagraph>
      <RouterLink
        v-if="$route"
        :to="{ name: 'ankorstore-plus-signup' }"
      >
        <AkButton
          class="ds-mt-3"
          color="white"
        >
          {{ t('ankorstorePlus.cta.nonOptIn') }}
        </AkButton>
      </RouterLink>
    </template>
  </AkTooltipInformation>
</template>

<style scoped lang="scss">
.program_tooltip {
  @apply ds-h-3 ds-inline-block;
}
</style>
